class HeroSlider extends HTMLElement {
  connectedCallback() {
    if (typeof Splide === 'undefined') {
      document.querySelector('script[src*="splide"]')?.addEventListener('load', () => this.init());
    } else {
      this.init();
    }
  }

  init() {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const autoplay = this.dataset.autoplay === 'true' && !reduceMotion;
    const interval = parseInt(this.dataset.interval, 10) || 5000;

    this.splide = new Splide(this, {
      type: 'loop',
      role: 'region',
      label: 'Featured highlights',
      arrows: false,
      pagination: true,
      drag: true,
      autoplay,
      interval,
      pauseOnHover: true,
      pauseOnFocus: true,
      resetProgress: false,
      // No sliding animation for users who prefer reduced motion.
      speed: reduceMotion ? 0 : 600,
      easing: 'ease',
    });

    this.splide.on('mounted', () => this.setupAutoplayToggle(autoplay));
    this.splide.mount();
  }

  setupAutoplayToggle(autoplay) {
    const toggle = this.querySelector('[data-hero-autoplay-toggle]');
    if (!toggle) return;

    const autoplayComponent = this.splide?.Components?.Autoplay;
    // No autoplay (disabled or reduced-motion) → the control has nothing to do.
    if (!autoplay || !autoplayComponent) {
      toggle.remove();
      return;
    }

    toggle.addEventListener('click', () => {
      if (toggle.classList.contains('is-paused')) {
        autoplayComponent.play();
      } else {
        autoplayComponent.pause();
      }
    });

    // Keep the button in sync with the actual state (covers pause-on-hover/focus too).
    this.splide.on('autoplay:play', () => {
      toggle.classList.remove('is-paused');
      toggle.setAttribute('aria-label', 'Pause slideshow');
    });
    this.splide.on('autoplay:pause', () => {
      toggle.classList.add('is-paused');
      toggle.setAttribute('aria-label', 'Play slideshow');
    });
  }

  disconnectedCallback() {
    this.splide?.destroy();
  }
}

customElements.define('hero-slider', HeroSlider);
